"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inClientSide = void 0;
const inClientSide = () => {
    return typeof window !== 'undefined';
};
exports.inClientSide = inClientSide;
//# sourceMappingURL=inClientSide.js.map